export { BodegasTabs } from './Listar'
export { default as BodegaCrear } from './Crear'
export { default as BodegaVer } from  './Ver'
